module.exports = __webpack_public_path__ + "static/media/map-location.17ee361c.svg";